import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

type DspRestrictionTooltipProps = {
  tooltipTextLines: string[];
};

export const DspRestrictionTooltip = ({ tooltipTextLines }: DspRestrictionTooltipProps) => {
  return (
    <Tooltip
      title={tooltipTextLines.map((line, index) => (
        <div key={index} style={{ marginTop: index > 0 ? '12px' : '0px' }}>
          {line}
        </div>
      ))}
      placement="right"
      data-test="dsps-seats-tooltip"
    >
      <IconButton size="small">
        <InfoRoundedIcon />
      </IconButton>
    </Tooltip>
  );
};
